import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "passwordInput",
    "confirmInput",
    "eyeIcon",
    "eyeConfirmIcon",
    "toggleButton",
    "toggleConfirmButton"
  ]

  togglePassword() {
    this.toggleFieldVisibility(
      this.passwordInputTarget,
      this.eyeIconTarget
    )
  }

  toggleConfirm() {
    this.toggleFieldVisibility(
      this.confirmInputTarget,
      this.eyeConfirmIconTarget
    )
  }

  toggleFieldVisibility(inputField, iconElement) {
    const isPasswordType = inputField.type === "password"

    if (isPasswordType) {
      inputField.type = "text"
      iconElement.classList.remove("fa-eye")
      iconElement.classList.add("fa-eye-slash")
    } else {
      inputField.type = "password"
      iconElement.classList.remove("fa-eye-slash")
      iconElement.classList.add("fa-eye")
    }
  }
}
